import { Box, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";

import {
  HOME_SECTION_BAND_PADDING_Y,
  HOME_SECTION_HORIZONTAL_GUTTER,
  HOME_SECTION_HERO_PADDING_TOP,
} from "../constants/homePageSections";

/** Shared prose: larger readable type + one line rhythm */
const aboutBodySx = {
  fontSize: { xs: "1.125rem", md: "1.25rem" },
  lineHeight: 1.65,
};

const About = () => {
  const pastelColors = [
    "#FFE5E5",
    "#E5F3FF",
    "#E5FFE5",
    "#FFF5E5",
    "#F0E5FF",
    "#FFE5F0",
    "#E5FFFF",
    "#F5FFE5",
    "#FFE5FF",
    "#E5F5FF",
  ];

  const [currentColorIndex, setCurrentColorIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentColorIndex(
        (prevIndex) => (prevIndex + 1) % pastelColors.length,
      );
    }, 500);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        boxSizing: "border-box",
      }}
    >
      <Helmet>
        <title>About Loops — Find Food Deals in Malaysia</title>
        <meta name="description" content="Learn about Loops, Malaysia's food deal discovery platform. Find out our mission to help you discover affordable meals near you." />
        <meta property="og:title" content="About Loops — Find Food Deals in Malaysia" />
        <meta property="og:description" content="Learn about Loops, Malaysia's food deal discovery platform. Find out our mission to help you discover affordable meals near you." />
        <meta property="og:url" content="https://loopsfood.com/about" />
        <link rel="canonical" href="https://loopsfood.com/about" />
      </Helmet>
      <Box
        component="section"
        aria-label="About"
        sx={{
          width: "100%",
          maxWidth: 1040,
          mx: "auto",
          px: HOME_SECTION_HORIZONTAL_GUTTER,
          pt: HOME_SECTION_HERO_PADDING_TOP,
          pb: HOME_SECTION_BAND_PADDING_Y,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              borderRadius: "8px",
              backgroundColor: pastelColors[currentColorIndex],
              alignItems: "center",
              justifyContent: "center",
              width: "260px",
              height: "260px",
            }}
          >
            <img
              src="/assets/logo.png"
              alt="Loops Logo"
              style={{
                height: "60px",
              }}
            />
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          maxWidth: "700px",
          width: "100%",
          px: HOME_SECTION_HORIZONTAL_GUTTER,
          pb: HOME_SECTION_BAND_PADDING_Y,
          mx: "auto",
          boxSizing: "border-box",
        }}
      >
        <Typography
          variant="body1"
          sx={{
            ...aboutBodySx,
            textAlign: "left",
            mb: 2,
            color: "text.primary",
          }}
        >
          We started Loops to make it easier for everyone to track and discover
          deals. We're still growing, but our goal is to gather and share all
          the best deals across Malaysia, so you can always find a good deal
          near you.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            ...aboutBodySx,
            textAlign: "left",
            mb: 4,
            color: "text.primary",
          }}
        >
          Thanks for dropping by, and we hope you'll find your next meal here!
        </Typography>

        <Box
          sx={{
            textAlign: "left",
            mt: { xs: 4, md: 6 },
            pt: 3,
          }}
        >
          <Typography
            variant="body1"
            sx={{
              ...aboutBodySx,
              color: "text.secondary",
            }}
          >
            Loops Team
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default About;
